module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full"
  }, [_c('l-map', {
    attrs: {
      "zoom": _vm.zoom,
      "center": _vm.center,
      "min-zoom": _vm.minZoom,
      "max-zoom": _vm.maxZoom,
      "attributionControl": _vm.attributionControl,
      "zoomend": _vm.zoomend
    }
  }, [_c('l-tilelayer', {
    attrs: {
      "url": _vm.url,
      "attribution": _vm.attribution
    }
  }), _vm._v(" "), _c('l-marker', {
    attrs: {
      "position": _vm.offMapMarker,
      "title": _vm.title,
      "opacity": _vm.opacity,
      "draggable": _vm.draggable
    }
  }, [_c('l-tooltip', {
    attrs: {
      "content": "find lat lang"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.markers), function(m) {
    return _c('l-marker', {
      attrs: {
        "position": m.coords,
        "title": _vm.title,
        "opacity": _vm.opacity,
        "draggable": false
      }
    }, [_c('l-popup', {
      attrs: {
        "heading": m.heading,
        "content": m.content,
        "link": m.link
      }
    })], 1)
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05b238ea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Layout.vue
// module id = 91
// module chunks = 1